export const contactDataSubjects = [
  {
    value: 'nehoda',
    label: 'Nehoda'
  },
  {
    value: 'půjčovna',
    label: 'Půjčovna'
  },
  {
    value: 'ostatní',
    label: 'Ostatní'
  }
];
